import React, { useState } from 'react';
import '../../scss/welcome-header.style.scss';
import celebrationIcon from '../../../assets/cf3f2a543ada403e306efb6e6dd7b8927e5e512b.svg';
import closeIcon from '../../../assets/5238f7a85564ca6ad45a8183e69e8f79d787a245.svg';
import { useAppDispatch } from '../../hooks/useRedux';
import { updateUserOnboardingService } from '../../features/userOnboarding/userOnboarding.slice';
import { getUserOnboarding } from '../../../redux/auth/authSlice';

interface WelcomeHeaderProps {
  t: (key: string) => string;
  title?: string;
  subtitle?: string;
  className?: string;
}

export const WelcomeHeader = ({
  t,
  title = "WELCOME_TO_INVOZIO",
  subtitle = "YOUR_JOURNEY_TO_TOP_TIER_INVOICING_STARTS_HERE_CONFIGURE_YOUR_INVOICE_THE_WAY_YOU_WANT",
  className = "",
}: WelcomeHeaderProps) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [skipped, setSkipped] = useState(false);

  async function handleSkip() {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await dispatch(updateUserOnboardingService({ actionType: 'IsSkipForNow', value: true })).unwrap();
      setSkipped(true);
      try { dispatch(getUserOnboarding()); } catch (e) { /* ignore */ }
    } catch (err) {
      console.error('Failed to skip onboarding', err);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className={`welcome-header ${className}`} data-testid="welcome-header">
      <div className="welcome-header__content">
        {/* <div className="welcome-header__icon">
          <img 
            src={celebrationIcon} 
            alt="Celebration" 
            className="welcome-header__celebration-icon"
          />
        </div> */}
        <div className="welcome-header__text">
          <h1 className="welcome-header__title">{t(title)}</h1>
          <p className="welcome-header__subtitle">{t(subtitle)}</p>
        </div>
        
        {!skipped && (
          <button 
            className="welcome-header__skip-button"
            type="button"
            aria-label="Skip for now"
            data-testid="skip-button"
            onClick={() => handleSkip()}
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            <span className="welcome-header__skip-text">{t('SKIP_FOR_NOW')}</span>
            <img 
              src={closeIcon} 
              alt="Close" 
              className="welcome-header__close-icon"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default WelcomeHeader;
